import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
  ViewChild,
  SimpleChanges,
  AfterViewInit,
  ChangeDetectorRef,
} from "@angular/core";
import { UserService } from "app/shared/services/user.service";
import { Chart } from "chart.js";
import { CYD, Credential } from "../shared/models/credential";
import { Color } from "ng2-charts/lib/color";

@Component({
  selector: "app-graph",
  templateUrl: "./graph.component.html",
  styleUrls: ["./graph.component.css"],
})
export class GraphComponent implements OnInit, OnChanges, AfterViewInit {
  constructor(
    private userService: UserService,
    private cdRef: ChangeDetectorRef
  ) {}

  personId: string;
  public doughnutChartType: string = "doughnut";
  @ViewChild("progressChart", { static: true }) myId: ElementRef;
  @Input() cyd: CYD;
  @Input() credential: Credential;

  chartOptions = {
    cutoutPercentage: 85,
    circumference: Math.PI,
    rotation: Math.PI,
    legend: {
      display: false,
    },
    tooltips: {
      enabled: false,
    },
    events: [],
  };

  percentage: number;
  chartData = {
    datasets: [
      {
        data: [0, 0, 0],
        backgroundColor: ["#EE3333", "#FFEE88", "#66CC66"],
        borderWidth: 0,
        hoverBorderWidth: 0,
      },
    ],
  };
  chartLabels: string[] = ["Low", "Medium", "High"];
  public colors: Array<Color> = [{}];
  ctx: any;
  currentYear: string;
  previousYear: string;
  crcePercentage: number;
  crcePercentagePreviousYear: number;
  chart: Chart;

  ngOnInit() {
    this.personId = this.userService.CurrentUser.personId;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.cyd && this.cyd) {
      this.updateChartData();
      if (this.chart) {
        this.chart.update();
      }
    }
    this.updateCRCEProgressData();
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
    this.initializeChart();
  }

  private initializeChart() {
    if (!this.ctx) {
      this.ctx = this.myId.nativeElement.getContext("2d");
    }
    if (!this.chart) {
      this.chart = new Chart(this.ctx, {
        type: "doughnut",
        data: this.chartData,
        options: this.chartOptions,
        plugins: [
          {
            afterRender: (chartObj) =>
              this.renderPoint(chartObj, this.percentage),
          },
        ],
      });
    }
  }

  private updateChartData() {
    if (this.cyd) {
      this.chartData.datasets[0].data = [
        this.cyd.lowCutScore,
        this.cyd.highCutScore - this.cyd.lowCutScore,
        this.cyd.maxScore - this.cyd.highCutScore,
      ];
      this.percentage = this.cyd.currentGraphScore / this.cyd.maxScore;
    }
  }

  private updateCRCEProgressData() {
    if (this.credential && this.credential.assessmentGroup) {
      if (this.credential.crceYear) {
        this.currentYear = this.credential.crceYear.toString();
        this.crcePercentage = Math.round(
          (this.credential.questionAnsweredCountForCurrentYearCRCE /
            this.credential.questionCountForCurrentYearCRCE) *
            100
        );
      }

      if (this.credential.crcePreviousYear) {
        this.previousYear = this.credential.crcePreviousYear.toString();
        this.crcePercentagePreviousYear = Math.round(
          (this.credential.questionAnsweredCountForPreviousYearCRCE /
            this.credential.questionCountForPreviousYearCRCE) *
            100
        );
      }
    }
  }

  private renderPoint(chart, percentage) {
    const chartRadius = chart.height;
    const chartCutoutRadius =
      (chartRadius * chart.config.options.cutoutPercentage) / 100;
    const chartArcThickness = chartRadius - chartCutoutRadius;
    const adjustedChartRadius = chartRadius - chartArcThickness / 2;
    const pointRadius = chartArcThickness / 3;
    const constrainedPercentage = this.constrainPercentage(percentage);
    const angle = (180 * constrainedPercentage - 90) * (Math.PI / 180);

    const x = chartRadius + (adjustedChartRadius - 2) * Math.sin(angle);
    const y = chartRadius - adjustedChartRadius * Math.cos(angle);

    this.ctx.beginPath();
    this.ctx.fillStyle = "#000000";
    this.ctx.arc(x, y, pointRadius, 0, Math.PI * 2);
    this.ctx.fill();
  }

  private constrainPercentage(percentage) {
    return Math.min(Math.max(percentage, 0.02), 0.98);
  }
}
